import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { Header } from './@shared/components/header/header';
import { Footer } from './@shared/components/footer/footer';
import {ButtonComponent} from './@shared/components/button/button.component';
import { Home } from './pages/home/home';
import { Shows } from './pages/shows/shows';
import { EventDetails } from './pages/event-details/event-details';
import { Results } from './pages/results/results';
import { News } from './pages/news/news';
import { Membership } from './pages/membership/membership';
import { Rulebook } from './pages/rulebook/rulebook';
import { About } from './pages/about/about';
import {provideHttpClient} from '@angular/common/http';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import { UserProfile } from './pages/user-profile/user-profile';
import { UserProfileHeader } from './pages/user-profile/components/user-profile-header/user-profile-header';
import { UserProfileOverview } from './pages/user-profile/components/user-profile-overview/user-profile-overview';
import { UserProfileHorses } from './pages/user-profile/components/user-profile-horses/user-profile-horses';
import { HorseCard } from './@shared/components/horse-card/horse-card';
import { AddHorse } from './pages/user-profile/components/user-profile-horses/components/add-horse/add-horse';
import { EditHorse } from './pages/user-profile/components/user-profile-horses/components/edit-horse/edit-horse';
import { ModalComponent } from './@shared/components/modal-component/modal-component';
import { InputComponent } from './@shared/components/input-component/input-component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Selectorini } from './@shared/components/selectorini/selectorini';
import { Fileorini } from './@shared/components/fileorini/fileorini';
import { DeleteModal } from './@shared/components/delete-modal/delete-modal';
import { EditUserProfile } from './pages/user-profile/components/user-profile-overview/components/edit-user-profile/edit-user-profile';
import { Centered } from './@shared/components/layouts/centered/centered';
import { ThreeColumn } from './@shared/components/layouts/three-column/three-column';
import { PictureLeft } from './@shared/components/layouts/picture-left/picture-left';
import { PictureRight } from './@shared/components/layouts/picture-right/picture-right';
import { UserProfileMembership } from './pages/user-profile/components/user-profile-membership/user-profile-membership';
import { AddMembership } from './pages/user-profile/components/user-profile-membership/components/add-membership/add-membership';
import { PurchaseMembership } from './pages/user-profile/components/user-profile-membership/components/purchase-membership/purchase-membership';
import { UserProfileOrganisations } from './pages/user-profile/components/user-profile-organisations/user-profile-organisations';
import { CreateOrganisation } from './pages/user-profile/components/user-profile-organisations/components/create-organisation/create-organisation';
import { HeaderCompanySelect } from './@shared/components/header/components/header-company-select/header-company-select';
import { CompanyProfile } from './pages/company-profile/company-profile';
import { CompanyProfileOverview } from './pages/company-profile/components/company-profile-overview/company-profile-overview';
import { CompanyProfileMembershipPlans } from './pages/company-profile/components/company-profile-membership-plans/company-profile-membership-plans';
import { AddMembershipPlan } from './pages/company-profile/components/company-profile-membership-plans/components/add-membership-plan/add-membership-plan';
import { EditMembershipPlan } from './pages/company-profile/components/company-profile-membership-plans/components/edit-membership-plan/edit-membership-plan';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import { MarkdownEditorini } from './@shared/components/markdown-editorini/markdown-editorini';
import { EditCompanyProfile } from './pages/company-profile/components/company-profile-overview/components/edit-company-profile/edit-company-profile';
import { EditCompanyImages } from './pages/company-profile/components/company-profile-overview/components/edit-company-images/edit-company-images';
import { Carouselorini } from './@shared/components/carouselorini/carouselorini';
import { CompanyProfileEvents } from './pages/company-profile/components/company-profile-events/company-profile-events';
import { AddEvent } from './pages/company-profile/components/company-profile-events/components/add-event/add-event';
import { EventCard } from './@shared/components/event-card/event-card';
import { ManageEvent } from './pages/company-profile/components/company-profile-events/components/manage-event/manage-event';
import { UpdateEventImage } from './pages/company-profile/components/company-profile-events/components/manage-event/components/update-event-image/update-event-image';
import { UpdateCompanyImage } from './pages/company-profile/components/update-company-image/update-company-image';
import { ManageEventOverview } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-overview/manage-event-overview';
import { ManageEventClasses } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-classes/manage-event-classes';
import { AddClass } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-classes/components/add-class/add-class';
import { EditClass } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-classes/components/edit-class/edit-class';
import { EditRegistration } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-classes/components/view-class-registrations/components/edit-registration/edit-registration';
import { EditEvent } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-overview/components/edit-event/edit-event';
import { EditEventImages } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-overview/components/edit-event-images/edit-event-images';
import { ManageEventService } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-service/manage-event-service';
import { AddEventService } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-service/components/add-event-service/add-event-service';
import { EditEventService } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-service/components/edit-event-service/edit-event-service';
import { SponsorCard } from './@shared/components/sponsor-card/sponsor-card';
import { ManageEventSponsor } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-sponsor/manage-event-sponsor';
import { AddSponsor } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-sponsor/components/add-sponsor/add-sponsor';
import { EditSponsor } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-sponsor/components/edit-sponsor/edit-sponsor';
import { ManageEventContacts } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-contacts/manage-event-contacts';
import { AddContact } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-contacts/components/add-contact/add-contact';
import { EditContact } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-contacts/components/edit-contact/edit-contact';
import { EventRegistrationComponent } from './pages/event-registration/event-registration';
import { ViewClassRegistrations } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-classes/components/view-class-registrations/view-class-registrations';
import { ViewServiceRegistrations } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-service/components/view-service-registrations/view-service-registrations';
import { EditServiceRegistration } from './pages/company-profile/components/company-profile-events/components/manage-event/components/manage-event-service/components/view-service-registrations/components/edit-service-registration/edit-service-registration';
import { VerifyEmail } from './pages/auth/verify-email/verify-email';

@NgModule({
  declarations: [
    App,
    Header,
    Footer,
    Home,
    Shows,
    EventDetails,
    Results,
    News,
    Membership,
    Rulebook,
    About,
    UserProfile,
    UserProfileHeader,
    UserProfileOverview,
    UserProfileHorses,
    HorseCard,
    AddHorse,
    EditHorse,
    ModalComponent,
    InputComponent,
    Selectorini,
    Fileorini,
    DeleteModal,
    EditUserProfile,
    Centered,
    ThreeColumn,
    PictureLeft,
    PictureRight,
    UserProfileMembership,
    AddMembership,
    PurchaseMembership,
    UserProfileOrganisations,
    CreateOrganisation,
    HeaderCompanySelect,
    CompanyProfile,
    CompanyProfileOverview,
    CompanyProfileMembershipPlans,
    AddMembershipPlan,
    EditMembershipPlan,
    EditCompanyProfile,
    EditCompanyImages,
    Carouselorini,
    CompanyProfileEvents,
    AddEvent,
    EventCard,
    ManageEvent,
    UpdateEventImage,
    UpdateCompanyImage,
    ManageEventOverview,
    ManageEventClasses,
    AddClass,
    EditClass,
    EditRegistration,
    EditEvent,
    EditEventImages,
    ManageEventService,
    AddEventService,
    EditEventService,
    SponsorCard,
    ManageEventSponsor,
    AddSponsor,
    EditSponsor,
    ManageEventContacts,
    AddContact,
    EditContact,
    EventRegistrationComponent,
    ViewClassRegistrations,
    ViewServiceRegistrations,
    EditServiceRegistration,
    VerifyEmail
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    ButtonComponent,
    FormsModule,
    CKEditorModule,
    MarkdownEditorini,
    ReactiveFormsModule,
    NgbTooltipModule
  ],
  providers: [
    provideHttpClient(),
    provideBrowserGlobalErrorListeners(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: 'en'
    }),
  ],
  bootstrap: [App]
})
export class AppModule { }
